/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPsychologyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-psychology"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.5 13.65L10.63 14.47Q10.68 14.72 10.85 14.89Q11.03 15.05 11.28 15.05L12.57 15.05Q12.82 15.05 13 14.89Q13.18 14.72 13.22 14.47L13.35 13.65Q13.43 13.6 13.51 13.55Q13.6 13.5 13.65 13.45L14.43 13.72Q14.65 13.8 14.88 13.71Q15.1 13.63 15.22 13.43L15.85 12.3Q15.97 12.07 15.94 11.84Q15.9 11.6 15.7 11.45L15.1 11Q15.1 10.88 15.1 10.75Q15.1 10.63 15.1 10.5L15.7 10.05Q15.9 9.9 15.94 9.66Q15.97 9.43 15.85 9.2L15.22 8.07Q15.1 7.88 14.88 7.79Q14.65 7.7 14.43 7.78L13.65 8.05Q13.6 8 13.51 7.95Q13.43 7.9 13.35 7.85L13.22 7.03Q13.18 6.78 13 6.61Q12.82 6.45 12.57 6.45L11.28 6.45Q11.03 6.45 10.85 6.61Q10.68 6.78 10.63 7.03L10.5 7.85Q10.43 7.9 10.34 7.95Q10.25 8 10.2 8.05L9.43 7.78Q9.2 7.7 8.97 7.79Q8.75 7.88 8.63 8.07L8 9.2Q7.88 9.43 7.91 9.66Q7.95 9.9 8.15 10.05L8.75 10.5Q8.75 10.63 8.75 10.75Q8.75 10.88 8.75 11L8.15 11.45Q7.95 11.6 7.91 11.84Q7.88 12.07 8 12.3L8.63 13.43Q8.75 13.63 8.97 13.71Q9.2 13.8 9.43 13.72L10.2 13.45Q10.25 13.5 10.34 13.55Q10.43 13.6 10.5 13.65ZM11.93 12.3Q11.93 12.3 11.6 12.3Q11.28 12.3 10.82 11.85Q10.38 11.4 10.38 10.75Q10.38 10.1 10.82 9.65Q11.28 9.2 11.93 9.2Q12.57 9.2 13.03 9.65Q13.47 10.1 13.47 10.75Q13.47 11.4 13.03 11.85Q12.57 12.3 11.93 12.3ZM7 22.32Q6.45 22.32 6.06 21.94Q5.67 21.55 5.67 21L5.67 17.85Q4.25 16.5 3.46 14.72Q2.67 12.95 2.67 11Q2.67 7.13 5.4 4.4Q8.13 1.68 12 1.68Q15.22 1.68 17.74 3.59Q20.25 5.5 21 8.55L22.27 13.68Q22.43 14.3 22.04 14.81Q21.65 15.32 21 15.32L19.32 15.32L19.32 17.68Q19.32 18.8 18.56 19.56Q17.8 20.32 16.68 20.32L15.32 20.32L15.32 21Q15.32 21.55 14.94 21.94Q14.55 22.32 14 22.32Z" fill={color} />
    </svg>
  );
}
